












import Vue from "vue";
import Component from "vue-class-component";

interface Window {
  openCvLoadPromise: Promise<any>;
}
declare var window: Window;

@Component({})
export default class ImageSelect extends Vue {
  openCvLoaded = false;
  imageFile?: File;
  isSelectedImage: boolean = false;

  created() {
    window.openCvLoadPromise.then(() => {
      this.openCvLoaded = true;
    });
  }

  async selectedImage(imageFile: File) {
    this.imageFile = imageFile;
    this.isSelectedImage = !!imageFile;
  }

  judge() {
    this.$emit("imageSelected", this.imageFile);
  }
}
